<script lang="ts">
  import Card from '@smui/card';
  // import type { Options } from '@splidejs/splide';
  // import { Splide, SplideSlide } from '@splidejs/svelte-splide';
  import { afterUpdate, createEventDispatcher, onMount } from 'svelte';
  import { getAppConfig } from '../../../../common/config/app-config';
  import { getStr, globalCurrencyTag, isDirectionRTL, isMobileWidth } from '../../../../common/util';
  import ExtraCheckBox from '../../../common/components/ExtraCheckBox.svelte';
  import Text from '../../../common/components/Text.svelte';
  import Tag from '../../../common/components/tag/Tag.svelte';
  import { selectedFrequentProds } from '../../store/pdp_store';
  import PdpButton from '../PdpButton.svelte';
  import ManualBundleBottomPriceSection from './ManualBundleBottomPriceSection.svelte';
  import { getManualBundlePrice } from './ManualBundleCalculator';
  import ManualBundlePriceTile from './ManualBundlePriceTile.svelte';

  export let manualBundleData: any;
  export let preorder: boolean = false;
  let selectedProds = [manualBundleData?.code];
  var finalPrice = manualBundleData?.price && manualBundleData?.price.value;

  // var bundleLength =
  //   (manualBundleData?.manualBundleProducts?.length &&
  //     manualBundleData?.manualBundleProducts[0].bundleProducts.length) ||
  //   0;

  function redirectToPdp(e, url) {
    if (e.target.className.includes('mdc-checkbox__native-control')) {
      return;
    }
    window.location = url;
  }

  afterUpdate(() => {
    $selectedFrequentProds = selectedProds;
  });

  onMount(() => {
    $selectedFrequentProds = selectedProds;
  });

  const dispatcher = createEventDispatcher();

  function manualBundleToCart() {
    dispatcher('manualBundleToCart', {
      prodsSelected: $selectedFrequentProds,
    });
    selectedProds = [manualBundleData?.code];
  }

  function handleClick(e) {
    if (e.target.checked) {
      selectedProds.push(e.target.value);
      $selectedFrequentProds = selectedProds;
    } else {
      selectedProds = selectedProds.filter(item => item !== e.target.value);
      $selectedFrequentProds = selectedProds;
    }
  }

  $: cartItems = selectedProds && selectedProds.length;
  const pageLabels = window['ACC'].config.pageLabels || {};

  $: finalPrice = getManualBundlePrice(selectedProds, manualBundleData?.manualBundleProducts);

  const { currency } = getAppConfig();

  // var isSmallScreen = window.matchMedia('only screen and (max-width: 1275px)').matches || false;

  const isRTL = isDirectionRTL();
  // let thumbnailSlider: SplideSlide;
  // const thumbnailSliderOptions: Options = {
  //   type: 'slide',
  //   arrows: bundleLength >= 4 ? true : false,
  //   direction: (isRTL && 'rtl') || 'ltr',
  //   cover: true,
  //   wheel: false,
  //   perPage: 1,
  //   perMove: 1,
  //   autoWidth: true,
  //   autoHeight: true,
  //   pagination: bundleLength > 3 ? true : isSmallScreen ? true : false,
  //   fixedWidth: 368,
  //   // width: "92vw",
  //   classes: {
  //     arrow: 'splide__arrow splideFre_arrow-bg arrowsFre-bg',
  //     prev: 'splide__arrow--prev splideFre_arrow-prev',
  //     next: 'splide__arrow--next splideFre_arrow-next',
  //     page: 'splide__pagination__page splideFre_pagination-page ',
  //   },
  //   breakpoints: {
  //     900: {
  //       pagination: true,
  //       padding: { left: '1rem', right: '1rem' },
  //       wheel: true,
  //       fixedWidth: '98px',
  //       width: '91vw',
  //       perPage: 1,
  //       perMove: 1,
  //     },
  //   },
  // };
</script>

{#if manualBundleData?.manualBundleProducts?.length}
  <div class="fbt-bundle-container" class:rtl={isRTL} class:preorder-bundle={preorder}>
    <div class="fbt-bundle-container-mobTop" class:rtl={isRTL}>
      <span class="font-weight-bold"><Text key="extra.frequentlyBoughtLable" /></span>
    </div>
    <div class="card-container" class:preorder-bundle={preorder}>
      <section class="card-container-inn">
        {#each manualBundleData?.manualBundleProducts?.length && manualBundleData?.manualBundleProducts[0].bundleProducts as data, i}
          <div class:selected={selectedProds.includes(data.code)} class="card-container-inn-border">
            <Card class="card-container-inn-card" on:click={e => redirectToPdp(e, data.url)}>
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                class="card-container-inn-checkbox"
                on:click|stopPropagation={e => {
                  handleClick(e);
                }}
              >
                <!-- <Checkbox bind:group={selectedProds} value={data.code} /> -->
                <ExtraCheckBox bind:bindGroup={selectedProds} value={data.code} />
              </div>
              <div class="fbq-item-wrapper">
                <div class="left-wrapper">
                  {#if i === 0}
                    <div class="card-container-inn-tag">
                      <Tag
                        label={`${getStr('extra.pdp.currentlyviewinglable')}`}
                        fontSize={10}
                        theme="gray-bundle-desktop"
                      />
                    </div>
                  {/if}
                  {#if data.amplienceProductBaseUrl !== null}
                    <picture>
                      <source type="image/webp" srcset={data.amplienceProductBaseUrl + '&fmt=webp&w=150'} />
                      <source type="image/jpeg" srcset={data.amplienceProductBaseUrl + '&fmt=jpeg&w=150'} />
                      <img
                        class="card-container-inn-imgContaniner"
                        src={data.amplienceProductBaseUrl + '&w=150'}
                        alt={data.name}
                      />
                    </picture>
                  {/if}
                </div>
                <div class="right-wrapper">
                  <section class="card-container-inn-desc">
                    {#if isMobileWidth()}
                      <span class="font-weight-medium">{data.name}</span>
                    {:else}
                      <span class="font-weight-regular"
                        ><span
                          class="card-container-inn-desc-brandName font-weight-bold"
                          class:hidden={data.brandName === null}
                          >{data.brandName && data.brandName}
                        </span>
                        {data.name}</span
                      >
                    {/if}
                  </section>

                  <section class="price-wrapper">
                    <!-- <section class="card-container-inn-price" class:hidden={!isMobileWidth()}>
                      <span class="font-weight-regular font-size-xs d-flex justify-content-center price-for-mobile"
                        >{@html globalCurrencyTag}
                        <span class="font-weight-bold">{data.price && data.price.formattedValue}</span></span
                      >
                    </section> -->

                    <section>
                      <ManualBundlePriceTile
                        {currency}
                        price={data.price}
                        discountPrice={data.discountPrice}
                        tasheelPriceValuesList={data.tasheelPriceValuesList}
                        percentageDiscount={data.percentageDiscount}
                      />
                    </section>
                  </section>
                </div>
              </div>

              <!-- {#if i === 0 && isMobileWidth()}
                <div class="card-container-inn-tag">
                  <Tag label={`${getStr('extra.pdp.currentlyviewinglable')}`} fontSize={7} theme="gray-bundle" />
                </div>
              {/if} -->
            </Card>
          </div>

          <section class="card-container-inn-plus">
            <div class="card-container-inn-plus-vertical" />
            <div class="card-container-inn-plus-horizontal" />
          </section>
        {/each}
      </section>
      {#if isMobileWidth()}
        <div class="fbt-bundle-container-mobBottom">
          {#if finalPrice?.finalPrice > 0}
            <section class="fbt-bundle-container-mobBottom-first">
              <span class="font-weight-regular fbt-bundle-container-mobBottom-first-oriPrice"
                >{getStr('extra.pdp.buybundlelable')}</span
              >
            </section>
            <section class="fbt-bundle-container-mobBottom-second">
              <span class="font-weight-regular">
                {@html globalCurrencyTag}
                <span class="font-weight-bold">{finalPrice.finalPrice}</span>
                {#if finalPrice.finalTashleelAmount}
                  or {@html globalCurrencyTag}
                  <span class="font-weight-bold">{finalPrice.finalTashleelAmount}/{getStr('extra.pdp.monthLable')}</span
                  >
                {/if}
              </span>
            </section>
          {/if}
        </div>
      {/if}

      {#if isMobileWidth()}
        <div class="card-container-pdpButton">
          <PdpButton
            label={`${getStr('extra.pdp.addalltocartlable')}(${cartItems})`}
            type="primary"
            variant="solid"
            size="large"
            disabled={!finalPrice?.finalPrice ? true : false}
            on:click={() => manualBundleToCart()}
          />
        </div>
      {/if}
      {#if !isMobileWidth()}
        <section class="card-container-bottomSection" class:rtl={isRTL}>
          <ManualBundleBottomPriceSection
            {preorder}
            {currency}
            manualBundleProducts={manualBundleData?.manualBundleProducts}
            {selectedProds}
            {pageLabels}
            on:addManualBundleToCart={() => manualBundleToCart()}
          />
        </section>
      {/if}
    </div>
  </div>
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .fbq-item-wrapper {
    display: flex;
    flex-direction: row;
    padding: 6px 6px 6px 4px;
    gap: 4px;

    @include desktop-min-width {
      flex-direction: row;
      padding: 16px 16px 16px 16px;
      gap: 24px;
      width: 100%;
    }
    .left-wrapper {
      width: 112px;
      text-align: center;
    }
    .right-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 75%;
      :global {
        .price-wrapper {
          .price-and-extra {
            @include desktop-max-width {
              font-size: 12px;
              line-height: 14px;
            }
          }
        }
      }
    }
  }

  .fbt-bundle-container {
    &-mobTop {
      font-size: 20px;
      line-height: 22px;
      text-align: center;
      margin: 24px 0 16px 0;
      color: $neutral-dark-01;
      @include desktop-min-width {
        text-align: left;
        font-size: 36px;
        font-weight: 700;
        line-height: 40px;
      }
    }
    &-mobBottom {
      margin-top: 70px;
      text-align: center;
      &-first-oriPrice {
        font-size: 10px;
        line-height: 11px;
        color: $neutral-dark-03;
      }
      &-second {
        font-size: 10px;
        margin-bottom: 12px;
      }
    }
    &.preorder-bundle {
      .fbt-bundle-container-mobTop {
        @include desktop-min-width {
          margin: 10px 0 50px 48px;
        }
      }
    }
    &:not(.preorder-bundle) {
      .fbt-bundle-container-mobTop {
        @include desktop-min-width {
          margin: 30px 0;
        }
      }
      .fbt-bundle-container-mobBottom {
        @include desktop-max-width {
          margin-top: 24px;
        }
      }
    }
  }

  .card-container {
    display: flex;
    width: auto;
    height: auto;
    background: $primary-white;
    flex-direction: column;
    position: relative;

    &-bottomSection {
      @include desktop-min-width {
        &.rtl {
          margin-left: 0px;
        }
      }
    }

    &-pdpButton {
      padding: 0 16px 24px;
      :global {
        .btn {
          @include desktop-max-width {
            height: auto;
          }
        }
      }
    }

    &-text {
      padding: 16px 0 16px 16px;
      text-align: left;
      @include desktop-min-width {
        padding: 0px;
        display: grid;
        white-space: nowrap;
      }
    }

    &-inn {
      display: flex;
      padding: 0 24px 0 17px;

      &-price {
        .price-for-mobile {
          gap: 2px;
        }
      }
      &-border {
        border-radius: 6px;
        height: 100%;

        @include desktop-min-width {
          border-radius: 8px;
        }
        &:not(.selected) {
          border: 1px solid $secondary-gray-02;
        }

        &.selected {
          border: 1px solid $icon-only-icon-blue;
        }
      }

      &-tashleelPrice {
        left: 142px;
        bottom: 36px;
        position: absolute;

        &.rtl {
          right: 142px;
        }
      }

      &-tag {
        // text-align: left;
        // height: 14px;
        // margin-bottom: 10px;
        position: absolute;
        top: 8px;
        left: 8px;
        margin: 0;
      }

      @include desktop-min-width {
        padding: 0px;
        gap: 8px;
      }

      &-imgContaniner {
        // max-width: 86px;
        // max-height: 86px;
        // object-fit: contain;
        max-width: 110px;
        max-height: 110px;
        margin: 6px 6px 0;
        padding: 0;
      }

      &-desc {
        // font-size: 9px;
        // line-height: 10px;
        // font-weight: 500;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // color: $neutral-dark-03;
        // -webkit-line-clamp: 3;
        // margin-bottom: 2px;
        &-brandName::after {
          content: ' \2022 ';
        }

        margin: 0;
        margin-bottom: 8px;
        padding-right: 20px;
        font-size: 12px;
        line-height: 14px;
        width: auto;
        max-width: 198px;
        text-align: left;
        min-width: 182px;
        color: $neutral-dark-01;
        -webkit-line-clamp: 2;
        display: -webkit-box;
      }

      &-plus {
        &:last-child {
          display: none !important;
        }

        @include desktop-min-width {
          margin: 20px 0;
          min-height: 24px;
        }
      }
    }
  }

  :global {
    .card-container-inn {
      &-card {
        &.mdc-card {
          position: relative;
          font-size: 14px;
          // align-items: center;
          display: flex;
          background: $primary-white;
          // flex-direction: column;
          box-shadow: none;
          // max-width: 116px;

          height: auto;
          align-items: flex-start;
          flex-direction: row;
          border-radius: 12px;
          width: 100%;
          max-width: 100%;
        }
      }
      &-checkbox {
        .extra-checkbox {
          position: absolute;
          top: -4px;
          right: -4px;
          @include desktop-min-width {
            top: 4px;
            right: 4px;
          }
        }
        // .mdc-checkbox__background {
        //   border: 1.5px solid $icon-only-icon-blue !important;
        //   background-color: $primary-white !important;
        // }
        // .mdc-checkbox__checkmark {
        //   color: $icon-only-icon-blue !important;
        // }
      }

      .splide {
        width: 92vw;
        max-width: 100% !important;
      }

      .splideFre_arrow-bg {
        height: auto !important;
        width: auto !important;
        top: 50% !important;
      }
      .splide__arrow svg {
        @include desktop-min-width {
          // to make svg of width 15px and height auto
          width: 25.75px !important;
          height: auto !important;
          vertical-align: middle;
        }
        fill: $icon-only-icon-blue !important;
      }

      .splide__arrow:disabled svg {
        fill: $secondary-gray-01 !important;
      }

      .splide__list {
        transform-style: unset !important;
        direction: ltr;
      }

      .splide.splide--slide {
        .splide__track {
          margin-left: 33px;
          margin-right: 33px;
          @include desktop-max-width {
            margin-left: 11px;
            margin-right: 11px;
          }
          @include desktop-min-width {
            margin-left: 0;
            margin-right: 0;
          }
        }
        &.splide--ltr,
        &.splide--rtl {
          .splide__pagination {
            direction: ltr;
            .splideFre_pagination-page {
              top: 58px !important;
            }
          }
        }
        &.splide--rtl {
          .splide__arrows {
            .splide__arrow {
              &.splideFre_arrow-next,
              &.splideFre_arrow-prev {
                transform: scaleX(-1);
              }
            }
          }
        }

        .splide__pagination {
          .splide__pagination__page:hover {
            background-color: $color-grey-border;
          }
        }
      }
    }
  }

  .card-container {
    &:not(.preorder-bundle) {
      .fbq-item-wrapper {
        @include desktop-min-width {
          gap: 24px;
          width: 100%;
        }
        .left-wrapper {
          @include desktop-min-width {
            width: 112px;
            text-align: center;
          }
        }
        .right-wrapper {
          display: flex;
          flex-direction: column;
          justify-content: center;
          @include desktop-min-width {
            width: 75%;
          }
        }
      }

      @include desktop-min-width {
        border-radius: 8px;
      }

      .card-container-inn {
        @include desktop-min-width {
          display: block;
        }
        @include desktop-max-width {
          flex-direction: column;
        }
        .card-container-inn-plus {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          width: 100%;
          min-height: 44px;
          margin: 12px 0;
          @include desktop-max-width {
            margin: 2px 0;
          }
          .card-container-inn-plus-vertical,
          .card-container-inn-plus-horizontal {
            position: absolute;
            background-color: $secondary-gray-01;
          }

          .card-container-inn-plus-vertical {
            width: 2px;
            height: 18px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          .card-container-inn-plus-horizontal {
            width: 18px;
            height: 2px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      :global {
        .card-container-inn {
          .splide {
            @include desktop-min-width {
              width: auto;
            }
          }
          .splide__list {
            @include desktop-min-width {
              display: flex !important;
              flex-direction: column !important;
              align-items: center;
              gap: 0;
            }
          }
          .splide__slide {
            @include desktop-min-width {
              width: auto !important;
              min-width: 100% !important;
            }
          }

          .splide.splide--slide {
            @include desktop-min-width {
              .splide__arrows,
              .splide__pagination {
                display: none !important;
              }
            }
          }
          .card-container-inn-card {
            &.mdc-card {
              @include desktop-min-width {
                width: 100%;
                max-width: 100%;
              }
            }
          }
        }
      }
    }

    &.preorder-bundle {
      @include desktop-min-width {
        padding: 0 48px 10px;
        border-radius: 20px;
      }
      .fbq-item-wrapper {
        @include desktop-min-width {
          gap: 16px;
        }
      }

      .card-container-inn-plus {
        margin: 0 6px;
        @include desktop-min-width {
          margin: 0 20px;
          padding: 0 3px;
        }

        .card-container-inn-plus-vertical {
          width: 12px;
          background-color: $secondary-gray-01;
          color: $secondary-gray-01;
          height: 1px;
          position: absolute;
          top: 77px;

          @include desktop-min-width {
            width: 18px;
            top: 77px;
          }
        }

        .card-container-inn-plus-horizontal {
          width: 12px;
          background-color: $secondary-gray-01;
          transform: rotate(90deg);
          height: 1px;
          position: relative;
          top: 77px;
          @include desktop-min-width {
            width: 18px;
            top: 77px;
          }
        }
      }
      :global {
        .card-container-inn {
          .card-container-inn-card {
            &.mdc-card {
              @include desktop-min-width {
                width: 368px;
                max-width: 368px;
              }
            }
          }
        }
      }
    }
  }

  .hidden {
    display: none;
  }
</style>
